// ============================================================
//  MASAMADREAM — Countdown Timer
//  Fase 3: shows next activity name, pulses when due
// ============================================================

import { PROCESSES } from './data.js';
import { formatCountdown, setText } from './ui.js';

let _intervalId = null;

export function startCountdown(process, store) {
  stopCountdown();

  const pData = PROCESSES[process.type];
  if (!pData) return;

  function tick() {
    const state  = store.load();
    const active = state.activeProcess;
    if (!active) { stopCountdown(); return; }

    // Current day label
    setText('mm-current-day-label', `DÍA ${active.currentDay}`);

    // Find next incomplete activity
    const next    = _findNextActivity(active, pData.activities);
    const timerEl = document.getElementById('mm-countdown-timer');
    const nameEl  = document.getElementById('mm-countdown-name');

    if (!next) {
      // All done
      if (timerEl) { timerEl.textContent = '¡Proceso completo! 🎉'; timerEl.style.color = 'var(--mm-green)'; }
      if (nameEl)  nameEl.textContent = '';
      stopCountdown();
      return;
    }

    const remaining = next.scheduledAt - Date.now();

    if (nameEl) nameEl.textContent = `Próxima: ${next.action}`;

    if (timerEl) {
      if (remaining <= 0) {
        // Overdue — pulse
        timerEl.textContent = '¡Ahora! 🍞';
        timerEl.classList.add('is-due');
        timerEl.style.color = '';
      } else {
        timerEl.classList.remove('is-due');
        timerEl.textContent = formatCountdown(remaining);

        // Warning color < 30 min
        timerEl.style.color = remaining < 30 * 60 * 1000
          ? '#E65100'
          : '';
      }
    }
  }

  tick();
  _intervalId = setInterval(tick, 1000);
}

export function stopCountdown() {
  if (_intervalId !== null) {
    clearInterval(_intervalId);
    _intervalId = null;
  }
}

// ── Helpers ───────────────────────────────────────────────────
function _findNextActivity(activeProcess, activities) {
  const start        = new Date(activeProcess.startDate).getTime();
  const completedIds = activeProcess.completedIds;

  return activities
    .filter(a => !completedIds.includes(a.id))
    .map(a => ({
      ...a,
      scheduledAt: start + a.timeOffset * 60 * 60 * 1000,
    }))
    .sort((a, b) => a.scheduledAt - b.scheduledAt)[0] || null;
}
